export const sidebarMenusItems = [
  {
    name: 'Configurations',
    link: '/configurations',
  },
  {
    name: 'Hardware',
    link: '/devices',
  },
  {
    name: 'Printers',
    link: '/printers',
  },
]
